module.exports = ["cent","copy","divide","gt","lt","not","para","times"]